import * as React from 'react';
import classNames from 'classnames';
import { Theme, StyleRules } from '@material-ui/core/styles';
import withStyles, { ClassNameMap } from '@material-ui/core/styles/withStyles';
import {
  CssBaseline,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  Divider,
  Button,
} from '@material-ui/core';
import {
  Menu as MenuIcon,
  ChevronLeft as ChevronLeftIcon,
} from '@material-ui/icons';

const drawerWidth = 300;

const styles = (theme: Theme): StyleRules => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto',
  },
});

interface Props {
  classes: ClassNameMap;
  open: boolean;
  routeList: React.ReactNode;
  openDrawer: () => void;
  closeDrawer: () => void;
  goLoginPage: () => void;
}

interface State {
  username: string;
}

class Root extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      username: '',
    };
    this.logout = this.logout.bind(this);
    this.getName = this.getName.bind(this);
  }

  componentDidMount() {
    const { goLoginPage } = this.props;

    // トークンがない場合はログインページに戻る
    const cookiesGet = document.cookie;
    if (!cookiesGet.includes('access_token') || cookiesGet.split('=')[1] === '') {
      document.cookie = 'access_token=; expires=0';
      document.cookie = 'username=; expires=0';
      goLoginPage();
    }
    this.getName();
  }

  logout() {
    const { goLoginPage } = this.props;
    document.cookie = 'access_token=; expires=0';
    document.cookie = 'username=; expires=0';
    goLoginPage();
  }

  getName() {
    const cookies = document.cookie;
    let usernameVal = '';
    cookies.split(';').forEach((cookie) => {
      if (cookie.includes('username')) {
        usernameVal = cookie.split('=')[1];
      }
    });
    this.setState({ username: usernameVal });
  }

  render() {
    const { classes, children, open, routeList, openDrawer, closeDrawer } = this.props;

    return (
      <React.Fragment>
        <CssBaseline />
        <div className={classNames(classes.root, 'root-inner')}>
          <AppBar
            position="absolute"
            className={classNames(classes.appBar, open && classes.appBarShift, 'print-nodisp')}
          >
            <Toolbar disableGutters={!open} className={classes.toolbar}>
              <IconButton
                color="inherit"
                aria-label="Open Drawer"
                onClick={openDrawer}
                className={classNames(
                  classes.menuButton,
                  open && classes.menuButtonHidden,
                )}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" noWrap className={classes.title}>
                契約文書 Checker
              </Typography>
              {this.state.username ?
              <label style={{ margin : '20px' }}>ユーザ名：{this.state.username}</label>
              : ''}
            <Button
              variant="contained"
              color="secondary"
              onClick={this.logout}
            >
              ログアウト
            </Button>
            </Toolbar>
          </AppBar>
          <Drawer
            variant="permanent"
            classes={{
              paper: classNames(classes.drawerPaper, !open && classes.drawerPaperClose),
            }}
            className="print-nodisp"
            open={open}
          >
            <div className={classes.toolbarIcon}>
              <IconButton onClick={closeDrawer}>
                <ChevronLeftIcon />
              </IconButton>
            </div>
            <Divider />
            {routeList}
          </Drawer>
          <main className={classNames(classes.content, 'main-container')}>
            <div className={classes.appBarSpacer} />
            {children}
          </main>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(Root);



// WEBPACK FOOTER //
// ./src/components/Root.tsx